import Avatar1 from "../../assets/140.jpg";
import Avatar2 from "../../assets/IMG_2254.jpg";
import Avatar3 from "../../assets/avatar3.jpg";
import Avatar4 from "../../assets/IMG_1991.jpg";
import Avatar5 from "../../assets/IMG_3172.jpg";
import Avatar6 from "../../assets/IMG_3151.JPG";
import Avatar7 from "../../assets/IMG_1863.JPG";

const data = [
  {
    id: 1,
    quote:
      "Thank you Hartman for the work you have done. PHP is on the latest version. All the links and pictures are working as expected. The submit button on the contact form is working. The website is very responsive and load time is very fast. I am a very happy customer.",
    avatar: Avatar1,
    name: "Mr Derek Enyenihi",
    profession: "Assistant Secretary Edu.org.uk",
  },
  {
    id: 2,
    quote:
      "Good job, Hartman! Right on time! I really like how the project turned out, and my customers like it as well. It was fun collaborating with you.",
    avatar: Avatar2,
    name: "Joseph Okon",
    profession: "Entrepreneur",
  },
  {
    id: 3,
    quote: "Impressive work, buddy. Highly recommend!",
    avatar: Avatar3,
    name: "Daniel Akang ",
    profession: "Graphic Designer",
  },
  {
    id: 4,
    quote:
      "Wow. You finished earlier than you said. Everything's modern and beautifully done to the T. Great profession!",
    avatar: Avatar4,
    name: "Christie O",
    profession: "Singer",
  },
  {
    id: 5,
    quote: "I like how the app turned out. You are incredible, Hajia.",
    avatar: Avatar5,
    name: "Chukwugozie Ezenwa",
    profession: "Street Photographer",
  },
  {
    id: 6,
    quote: "Best developer in the world!",
    avatar: Avatar6,
    name: "Hajia Bintu",
    profession: "Brand Influencer",
  },
  {
    id: 7,
    quote: "Keep doing great stuff, dear! Nicely executed!",
    avatar: Avatar7,
    name: "Gloria Omoseh",
    profession: "Makeup Artist",
  },
];

export default data;
